import { Box, Fade, IconButton, Modal, Typography } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import AddPaymentVoucher from "../../pages/PrimeFigma/NewPaymentVoucherv2";

const style = {
  position: "absolute",
  left: "5%",
  right: "5%",
  // transform: 'translate(-50%, -50%)',
  bgcolor: "background.paper",
  boxShadow: 24,
  paddingBotoom: 2,
  outline: "none",
  // overflow: "scroll",
  height: "93vh",
};
function AddBalanceSheetPayment({
  open,
  setOpen,
  accountDetails,
  onSaveComplete,
}) {
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
      localStorage.removeItem("modalOpen")
    }
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Add Payment Entries
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          <Box
            className="custom-scrollbar"
            sx={{ overflow: "scroll", height: "80vh", padding:"10px" }}
          >
            {accountDetails?.accountsid && accountDetails?.label && (
              <AddPaymentVoucher
                paidTo={
                  accountDetails?.type === undefined
                    ? {
                        label: accountDetails?.label,
                        value: accountDetails?.accountsid,
                        AccountTypeFlag: accountDetails?.accounttypeflag,
                      }
                    : null
                }
                paidFrom={
                  accountDetails?.type !== undefined
                    ? {
                        label: accountDetails?.label,
                        value: accountDetails?.accountsid,
                        AccountTypeFlag: accountDetails?.accounttypeflag,
                      }
                    : null
                }
                method={accountDetails?.type}
                onSaveComplete={onSaveComplete}
              />
            )}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default AddBalanceSheetPayment;
